import React from 'react';
import CSelect, { Error } from 'src/components/form/Select';
import { ActionMeta, Props } from 'react-select';
import _ from 'lodash';
import { environmentTypeOptions } from 'src/api/types';
import { EnvironmentType } from 'src/graphql/_generated';

interface EnvironmentTypeSelectProps extends Omit<Props, 'value' | 'options'> {
  value: EnvironmentType | undefined | null;
  onChange: (value: { label: string; value: EnvironmentType }, meta: ActionMeta<any>) => void;
  onBlur?: () => void;
  error?: boolean;
  helperText?: string | false;
  disabled?: boolean;
  placeholder?: string;
  filteredOptions?: EnvironmentType[];
}

export const EnvironmentTypeSelect: React.FC<EnvironmentTypeSelectProps> = ({
  value,
  onChange,
  onBlur,
  error,
  helperText,
  disabled,
  placeholder = 'Select environment type',
  filteredOptions,
  ...rest
}) => {
  const options = filteredOptions?.length
    ? environmentTypeOptions.filter((option) => filteredOptions.includes(option.value))
    : environmentTypeOptions;

  const selectedValue = value ? _.find(options, (o) => o.value === value) : null;

  return (
    <>
      <CSelect
        isDisabled={disabled}
        value={selectedValue}
        placeholder={placeholder}
        options={options}
        onChange={onChange}
        onBlur={onBlur}
        inputId="environment-type-select"
        name="environmentType"
        {...rest}
      />
      {error && helperText && <Error>{helperText}</Error>}
    </>
  );
};
